import {
  FETCH_BUNDLE_BASKET_OFFERS_PENDING,
  FETCH_BUNDLE_BASKET_OFFERS_REJECTED,
  FETCH_BUNDLE_BASKET_OFFERS_FULFILLED,
  CLEAR_BUNDLE_BASKET_OFFER,
} from '../constants/bundleBasketOffers';

const initialState = {
  pending: true,
  basketOffersCampaigns: {},
  error: {},
  success: false,
};

export const bundleBasketOffers = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_BUNDLE_BASKET_OFFERS_PENDING:
      return {
        ...state,
        pending: true,
        success: false,
        basketOffersCampaigns: {},
        error: {},
      };

    case FETCH_BUNDLE_BASKET_OFFERS_REJECTED:
      return { ...state, pending: false, error: action.error };

    case FETCH_BUNDLE_BASKET_OFFERS_FULFILLED:
      return {
        ...state,
        basketOffersCampaigns: action.response,
        pending: false,
        error: {},
      };

    case CLEAR_BUNDLE_BASKET_OFFER:
      return initialState;

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/bundleBasketOffers.js